
const m = window.require("i18n");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
